import * as React from "react";
import { forwardRef } from "react";
const SvgIndeterminate = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 4, viewBox: "0 0 12 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 2L12 2", stroke: "currentColor", strokeWidth: 3, strokeLinejoin: "bevel" }));
const ForwardRef = forwardRef(SvgIndeterminate);
export { ForwardRef as ReactComponent };
